<form novalidate #updateEmForm="ngForm" (ngSubmit)="submit(updateEmForm)">
  <div class="modal-body">
    <div class="form-group row">
      <label class="col-md-12 col-form-label">氏名（漢字）</label>
      <div class="col-md-12 bisected-input-wrap form-group">
        <div class="bisected-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmLastName" name="emLastName" required placeholder="姓">
        </div>
        <span>&nbsp;</span>
        <div class="bisected-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmFirstName" name="emFirstName" required placeholder="名">
        </div>
      </div>
      <label class="col-md-12 col-form-label">氏名（かな）</label>
      <div class="col-md-12 bisected-input-wrap form-group">
        <div class="bisected-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmLastNameKana" name="emLastNameKana" required placeholder="せい">
        </div>
        <span>&nbsp;</span>
        <div class="bisected-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmFirstNameKana" name="emFirstNameKana" required placeholder="めい">
        </div>
      </div>
      <label class="col-md-12 col-form-label">続柄</label>
      <div class="col-md-12 form-group">
        <select [disabled]="busy || blocked" class="form-control" [(ngModel)]="newEmRelationship" name="emRelationship" required>
          <option [ngValue]="null">続柄</option>
          @for (rel of relationships; track rel.id) {
            <option [ngValue]="rel">{{ rel.name }}</option>
          }
        </select>
      </div>
      <label class="col-md-12 col-form-label">電話番号</label>
      <div class="col-md-12 trisection-input-wrap">
        <div class="trisection-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmPhone1" name="emPhone1" required pattern="[\x01-\x7E]+">
        </div>
        <span>&nbsp;</span>
        <div class="trisection-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmPhone2" name="emPhone2" required pattern="[\x01-\x7E]+">
        </div>
        <span>&nbsp;</span>
        <div class="trisection-input">
          <input [disabled]="busy || blocked" type="text" class="form-control" [(ngModel)]="newEmPhone3" name="emPhone3" required pattern="[\x01-\x7E]+">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn bg-close text-white" type="button" (click)="cancel.emit()" [disabled]="busy"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</button>
    <button class="btn btn-success" type="submit" [disabled]="updateEmForm.invalid || updateEmForm.pending || busy || blocked"><i class="fa s-icon-save"></i>&nbsp;保存</button>
  </div>
</form>
